export const ROUTE_HOME = '/'
export const ROUTE_STORE_DETAIL = '/detail'
export const ROUTE_ABOUT = '/about'
